/* eslint-disable @typescript-eslint/no-unsafe-return */
import type { Component } from 'vue';
import { defineAsyncComponent } from 'vue';

type ViewKey =
    | 'blog'
    | 'blogOverview'
    | 'contact'
    | 'dashboard-order'
    | 'dashboard-prescription'
    | 'faq'
    | 'home'
    | 'intervention'
    | 'interventionOverview'
    | 'login'
    | 'page'
    | 'passwordForgotten'
    | 'patientOrder'
    | 'patientOrderCompleted'
    | 'prescription'
    | 'register'
    | 'resetPassword';

const viewMap: Record<ViewKey, Component> = {
    'prescription': async () => import('@/components/views/prescribe.vue'),
    'blog': async () => import('@/components/views/blog.vue'),
    'blogOverview': async () => import('@/components/views/blog-overview.vue'),
    'faq': async () => import('@/components/views/faq.vue'),
    'home': async () => import('@/components/views/home.vue'),
    'page': async () => import('@/components/views/page.vue'),
    'login': async () => import('@/components/views/login.vue'),
    'interventionOverview': async () => import('@/components/views/product-overview-view.vue'),
    'patientOrder': async () => import('@/components/views/order.vue'),
    'intervention': async () => import('@/components/views/product.vue'),
    'patientOrderCompleted': async () => import('@/components/views/order-completed.vue'),
    'register': async () => import('@/components/views/register.vue'),
    'resetPassword': async () =>
        import('@/components/views/forgot-password/new-password-request.vue'),
    'passwordForgotten': async () =>
        import('@/components/views/forgot-password/reset-password.vue'),
    'contact': async () => import('@/components/views/contact.vue'),
    'dashboard-order': async () => import('~/components/views/dashboard/order-detail.vue'),
    'dashboard-prescription': async () =>
        import('~/components/views/dashboard/prescription-detail.vue'),
};

function isComponentKey(key: string): key is ViewKey {
    return key in viewMap;
}

export const mapToView = (alias: string): Component | null => {
    if (!isComponentKey(alias)) return null;
    return defineAsyncComponent(viewMap[alias] as () => Promise<Component>);
};
